<template>
  <div class="about-wrapper">
    <div class="header-about-background">
      <div
        data-aos="fade-up"
        data-aos-offset="200"
        data-aos-delay="50"
        data-aos-duration="1000"
        data-aos-easing="ease-in-out"
        class="header-title-container"
      >
        <h4>Lær</h4>
        <h2 class="about-header-title">Om oss</h2>
        <img class="about-title-logo" :src="about" />
      </div>
    </div>
    <div class="content-wrapper">
      <div class="content-intro-title-section">
        <h4>Historien</h4>
        <h1 class="content-intro-title">Hvem vi er</h1>
      </div>
      <div class="content-intro-wrapper">
        <div class="content-intro-section">
          <img
            data-aos="fade-in"
            data-aos-offset="200"
            data-aos-delay="50"
            data-aos-duration="1000"
            data-aos-easing="ease-in-out"
            class="team-photo"
            :src="team"
          />
          <div
            data-aos="fade-in"
            data-aos-offset="200"
            data-aos-delay="50"
            data-aos-duration="1000"
            data-aos-easing="ease-in-out"
            class="team-intro-text"
          >
            <p>
              Den første Fuji Sushi ble etablert i desember 2008 i Asker og vi
              er stolt av å være en servicebedrift for Askers lokale innbyggere
              i over 10 år. Med godt mottakelse av våre kunder har vi gjennom
              årene ekspandert til 4 andre steder i Østlandet. Vi har per dags
              dato avdelinger i Drammen, Jessheim, Slemmestad, Sandefjord og
              Asker.

              <br />
              <br />
              Vi er en familiebedrift som tilbyr kvalitet-sushi fra den
              tradisjonelle japanske kjøkken med en touch av familiens hemmelige
              ingredienser i risen og sausene. Etterhvert utviklet vi også flere
              menyer med fusjoner fra andre asiatiske kjøkken. Resten er ferske
              råvarer, og maten lages Ala minute og dette kjenner våre kunder
              til. Velkommen til oss og opplev sushi professjonelt, godt og
              rimelig.
            </p>
          </div>
        </div>
      </div>

      <div class="content-container">
        <div class="content-dual-wrapper">
          <div
            data-aos="fade-up"
            data-aos-offset="200"
            data-aos-delay="50"
            data-aos-duration="1000"
            data-aos-easing="ease-in-out"
            class="content-dual-title-section"
          >
            <h4>Kvalitet</h4>
            <h1 class="content-intro-title">Fra start til slutt</h1>
          </div>
          <div class="content-process-section">
            <div
              data-aos="fade-right"
              data-aos-offset="200"
              data-aos-delay="50"
              data-aos-duration="1000"
              data-aos-easing="ease-in-out"
              class="dual-images-holder"
            >
              <div class="dual-showcase-background">
                <img :src="dualBackground" />
              </div>
            </div>
            <div
              data-aos="fade"
              data-aos-offset="100"
              data-aos-delay="50"
              data-aos-duration="1000"
              data-aos-easing="ease-in-out"
              class="dual-images-text-holder"
            >
              <h3 class="dual-title">Ferske ingredienser</h3>
              <p class="dual-text">
                I Fuji Sushi bruker vi kun fersk råvare. Vi kjøper inn fersk
                fisk som vi selv fileterer og kutter fisken til perfekte skiver
                som gir deg en nydelig sushi opplevelse som mange av våre kunder
                allerede kjenner til.
              </p>
            </div>
          </div>
        </div>
        <div class="content-dual-wrapper">
          <div class="content-process-section-second">
            <div
              data-aos="fade"
              data-aos-offset="100"
              data-aos-delay="50"
              data-aos-duration="1000"
              data-aos-easing="ease-in-out"
              class="dual-images-text-holder-second"
            >
              <h3 class="dual-title-second">Dyktige kokker</h3>
              <p class="dual-text-second">
                Vi har dyktige kokker med mange års erfaringer som tilbereder
                maten din nøye, raskt og akkurat som du ønsker det.
              </p>
            </div>
            <div
              data-aos="fade-left"
              data-aos-offset="300"
              data-aos-delay="50"
              data-aos-duration="1000"
              data-aos-easing="ease-in-out"
              class="dual-images-holder-second"
            >
              <div class="dual-showcase-foreground-second">
                <img :src="dualForeground" />
              </div>
            </div>
          </div>
        </div>
        <div class="content-dual-wrapper">
          <div class="content-process-section">
            <div
              data-aos="fade-right"
              data-aos-offset="100"
              data-aos-delay="50"
              data-aos-duration="1000"
              data-aos-easing="ease-in-out"
              class="dual-images-holder"
            >
              <div class="dual-showcase-background">
                <img :src="resultSushi" />
              </div>
            </div>
            <div
              data-aos="fade"
              data-aos-offset="100"
              data-aos-delay="50"
              data-aos-duration="1000"
              data-aos-easing="ease-in-out"
              class="dual-images-text-holder"
            >
              <h3 class="dual-title">Topp kvalitet</h3>

              <p class="dual-text">Resultatet blir delikat og fortreffelig!</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  metaInfo : {
    title : 'Om Oss',
    titleTemplate: 'Fuji Sushi - %s',
    htmlAttrs : {
      lang : 'nb-NO'
    },
    meta : [
      { charset: 'utf-8'},
      { name: 'description', content : 'Den første Fuji Sushi ble etablert i desember 2008 i Asker og vi er stolt av å være en servicebedrift for Askers lokale innbyggere i over 10 år. Med godt mottakelse av våre kunder har vi gjennom årene ekspandert til 4 andre steder i Østlandet. Vi har per dags dato avdelinger i Drammen, Jessheim, Slemmestad, Sandefjord og Asker'}
    ]
  },
 
  components: {},
  data() {
    return {
      about: require("@/assets/images/calli-great.png"),
      team: require("@/assets/images/teamphoto.jpg"),
      dualBackground: require("@/assets/images/9.jpg"),
      dualForeground: require("@/assets/images/14.jpg"),
      resultSushi: require("@/assets/images/12.jpg")
    };
  }
};
</script>

<style lang="scss" scoped>
$desktop: 1200px;
$laptop: 1024px;
$tablet: 768px;
$mobile: 480px;

.dual-images-text-holder-second {
  padding: 7em 0 0 14em;
  font-size: calc(16px + 0.2vw);
  text-align: right;

  @media (width: 1280px) {
    padding: 4em 0 0 6em;
  }
  @media (max-width: 1024px) {
    padding: 0em 0 0 0em;
  }
  @media (max-width: $mobile) {
    text-align: center;
  }
  & p {
    font-family: Roboto, sans-serif;
    font-weight: 500;
  }
}
.dual-images-holder-second {
  display: flex;
  justify-content: flex-end;
  margin: 0 9rem;

  @media (width: 1280px) {
    margin: 0 6rem;
  }
  @media (max-width: 1024px) {
    margin: 0 2rem;
  }
}

.dual-title-second {
  font-size: 35px;
  font-family: bebas;
}

.dual-text-second {
  color: #878787;
  margin-top: 20px;
  line-height: 30px;
}
.dual-images-holder {
  margin: 0 9rem;
  @media (width: 1280px) {
    margin: 0 6rem;
  }
  @media (max-width: 1024px) {
    margin: 0 2rem;
  }

  & img {
    border-radius: 10%;
  }
}

.dual-images-text-holder {
  padding: 7em 14em 0 0;
  font-size: calc(16px + 0.2vw);
  color: #000000;
  @media (width: 1280px) {
    padding: 4em 6em 0 0;
  }
  @media (max-width: 1024px) {
    padding: 0em 0em 0 0;
  }
  @media (max-width: $mobile) {
    text-align: center;
  }
  & p {
    font-family: Roboto, sans-serif;
    font-weight: 500;
  }
}
.dual-title {
  font-size: 35px;
  font-family: bebas;
}

.dual-text {
  color: #878787;
  margin-top: 20px;
  line-height: 30px;
}
.dual-showcase-foreground-second {
  position: relative;
  border-radius: 10%;

  & img {
    border-radius: 10%;
  }
}
.dual-showcase-foreground {
  position: relative;
  left: 35%;
  bottom: 35%;
}
.dual-showcase-background {
  box-shadow: 2px 10px 21px -5px rgba(0, 0, 0, 0.75);
  height: auto;
  border-radius: 10%;
}

.content-dual-wrapper {
  margin-top: 20px;
}
.content-dual-title-section {
  margin-top: 10rem;
  @media (max-width: $mobile) {
    margin-top: 15rem;
  }
}

.content-process-section-second {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  @media (max-width: $mobile) {
    display: flex;

    flex-direction: column-reverse;
  }
}
.content-process-section {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));

  @media (max-width: $mobile) {
    display: flex;
    flex-direction: column;
  }
}

.content-intro-section {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  grid-gap: 1rem;
}

.team-intro-text {
  font-family: Roboto, sans-serif;
  font-size: calc(16px + 0.2vw);
  line-height: 2em;
  text-align: center;
  margin-left: 5%;
  font-weight: 700;
}
.content-wrapper {
  margin: 0;
  font-family: Roboto, sans-serif;
  overflow: hidden;

  @media (max-width: $mobile) {
    margin: 0;
  }
}

.content-intro-wrapper {
  margin: 0 6.5vw 0 6.5vw;
  background-image: url("~@/assets/images/brush-stroke.png");

  background-size: 70%;
  background-repeat: no-repeat;
  height: 700px;
  background-position: -60px 110px;
}
.content-intro-title-section {
  margin-bottom: 80px;
}
.team-photo {
  height: auto;
  border-radius: 8%;
  max-height: 500px;
  box-shadow: 2px 10px 21px -5px rgba(0, 0, 0, 0.75);
  @media screen and (max-width: 2600px) and (min-width: 2000px) {
    margin-left: 100px;
  }
}

.content-intro-title {
  margin-bottom: 10rem;
  text-align: center;
  text-transform: uppercase;
  font-size: 58px !important;
  font-family: Bebas, sans-serif;
  font-weight: 400 !important;
}
.header-about-background {
  background-image: url("~@/assets/images/chef-team.jpg");
  background-size: cover;
  height: 490px;
  width: 100%;
  object-fit: cover;
  margin-top: 10px;
  display: grid;
  place-items: center;

  @media (max-width: $mobile) {
    height: 200px;
    position: static;
    bottom: 0;
  }
}

/* //.about-header-title {
  position: relative;
  bottom: 330px;
  text-transform: uppercase;
  font-family: Roboto, sans-serif;
  font-size: 50px;

  width: 100%;
  text-align: center;
}
 */
.header-title-container {
  background-color: white;

  height: 200px;
  width: 18%;
  border-radius: 50px;
  display: grid;
  place-items: center;
  @media (max-width: $mobile) {
    height: 105px;
    width: 50%;
    border-radius: 30px;
  }
}
h4 {
  text-align: center;
  font-family: Roboto, sans-serif;
  font-weight: 400 !important;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 2px;
  color: #878787;
  position: relative;
  top: 25px;
  @media (max-width: $mobile) {
    font-size: 1em;
    top: 10px;
  }
}
.about-header-title {
  text-align: center;
  text-transform: uppercase;
  font-family: Bebas;
  font-weight: 400;
  margin: 0 0 0.67em 0;
  font-size: 2vw;
  margin: 0;
  @media (max-width: $mobile) {
    font-size: 2em;
    position: relative;
    bottom: 10px;
  }
}
.about-title-logo {
  position: relative;
  bottom: 20px;
  width: 80px;
  @media (max-width: $mobile) {
    height: 60px;
    width: auto;
  }
}
</style>
